import type { FC } from 'react';
import { type DropzoneOptions, useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { Button, Space, Typography } from '..';

type Props = {
  onDrop: DropzoneOptions['onDrop'];
  maxFiles?: number;
  disabled?: boolean;
};

export const DnD: FC<Props> = ({ onDrop, maxFiles, disabled }) => {
  const { t } = useTranslation();
  const { open, getRootProps, getInputProps } = useDropzone({
    maxFiles,
    multiple: maxFiles !== 1,
    noClick: true,
    onDrop,
    disabled,
  });

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        border: '2px dashed',
        backgroundColor: '#fff',
        ...getRootProps().style,
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Space direction="vertical" align="center">
        <Typography.Text strong>{t('drag-and-drop-file')}</Typography.Text>
        <Typography>{t('or')}</Typography>
        <Button
          type="primary"
          style={{ maxWidth: 224 }}
          onClick={open}
          disabled={disabled}
        >
          {t('select-file')}
        </Button>
      </Space>
    </div>
  );
};
